import { render } from "./switch.vue?vue&type=template&id=02571c6d&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=02571c6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02571c6d"

export default script